import type { MyStats } from '~/lib/api/types'
import { useMyStats } from './use-my-stats'
import styles from './settings-page.module.scss'

export function PersonalStatsStrip() {
  const { data, isLoading, isError } = useMyStats()

  if (isLoading || isError || !data) {
    return null
  }

  return <Strip stats={data.stats} />
}

function Strip({ stats }: { stats: MyStats }) {
  const completion = `${stats.month_submitted} / ${stats.month_expected}`
  const avg =
    stats.month_avg_hours != null
      ? `${stats.month_avg_hours.toFixed(1)} hrs`
      : '—'
  const longestSuffix =
    stats.longest_streak > stats.current_streak
      ? `best ${stats.longest_streak}`
      : 'all-time best'

  return (
    <section className={styles.statsStrip} aria-label="Your check-in stats">
      <Stat
        label={`Checked in · ${stats.month_label}`}
        value={completion}
        subvalue={daysWord(stats.month_expected)}
      />
      <Stat label="Avg hours / day" value={avg} />
      <Stat
        label="Current streak"
        value={`${stats.current_streak}`}
        subvalue={longestSuffix}
      />
    </section>
  )
}

function Stat({
  label,
  value,
  subvalue,
}: {
  label: string
  value: string
  subvalue?: string
}) {
  return (
    <div className={styles.statCard}>
      <span className={styles.statLabel}>{label}</span>
      <span className={styles.statValue}>{value}</span>
      {subvalue && <span className={styles.statSubvalue}>{subvalue}</span>}
    </div>
  )
}

function daysWord(n: number): string {
  return n === 1 ? 'expected day' : 'expected days'
}
